export const TRANSLATIONS_EN_SETTINGS_MICROSOFT = {
  "settings.microsoft.connect_button": "Connect Microsoft",
  "settings.microsoft.connecting": "Connecting...",
  "settings.microsoft.connected_success": "Microsoft connection completed.",
  "settings.microsoft.loading_status": "Loading Microsoft status...",
  "settings.microsoft.no_accounts": "No Microsoft accounts connected.",
  "settings.microsoft.selected_account": "Selected account",
  "settings.microsoft.select_account": "Select an account",
  "settings.microsoft.unnamed_account": "Unnamed account",
  "settings.microsoft.email_unavailable": "Email unavailable",
  "settings.microsoft.invalid_account": "Invalid account identity. Actions are disabled.",
  "settings.microsoft.malformed_status": "Microsoft status response is invalid. Account actions are disabled.",
  "settings.microsoft.status_error": "Could not load Microsoft status.",
  "settings.microsoft.connect_error": "Could not complete Microsoft authentication.",
  "settings.microsoft.disconnect_error": "Could not disconnect the Microsoft account.",
  "settings.microsoft.default_error": "Could not set the default Microsoft account.",
  "settings.microsoft.reauthorize_error": "Could not reauthorize the Microsoft account.",
  "settings.microsoft.popup_blocked": "The browser blocked the popup. Allow popups to continue.",
  "settings.microsoft.sync_period_saved": "Sync start date saved.",
  "settings.microsoft.sync_period_error": "Could not save the sync start date.",
  "settings.microsoft.sync_period_integer_error": "Select a valid date.",
  "settings.microsoft.sync_period_range_error": "Select a date between 365 days ago and today.",
  "settings.microsoft.save_sync_period": "Save date",
  "settings.microsoft.make_default": "Make default",
  "settings.microsoft.reauthorize": "Reauthorize",
  "settings.microsoft.disconnect": "Disconnect",
  "settings.microsoft.oauth_processing": "Processing Microsoft authentication...",
  "settings.microsoft.mail_preview_title": "Mail preview",
  "settings.microsoft.drive_preview_title": "Drive preview",
  "settings.microsoft.sharepoint_preview_title": "SharePoint preview",
  "settings.microsoft.no_preview_items": "No preview items to show.",
  "settings.microsoft.table.account": "Account",
  "settings.microsoft.table.status": "Status",
  "settings.microsoft.table.sync_period": "Sync from",
  "settings.microsoft.table.default": "Default",
  "settings.microsoft.table.actions": "Actions",
  "settings.microsoft.connected": "Connected",
  "settings.microsoft.connection_status_title": "Connection status",
  "settings.microsoft.sync_process_title": "Account Synchronization",
  "settings.microsoft.sync.mail_sync_status": "Mail sync status",
  "settings.microsoft.sync.drive_sync_status": "Drive sync status",
  "settings.microsoft.sync.last_mail_sync_at": "Last mail sync",
  "settings.microsoft.sync.last_drive_sync_at": "Last drive sync",
  "settings.microsoft.sync.last_read_email_date": "Last synchronized email date",
  "settings.microsoft.sync.last_sync_date": "Last sync date",
  "settings.microsoft.sync.emails_processed": "Emails processed",
  "settings.microsoft.sync.period": "Sync period",
  "settings.microsoft.sync.not_set": "Not set",
  "settings.microsoft.sync.all": "All",
  "settings.microsoft.diagnostics_title": "Diagnostics",
  "settings.microsoft.audit_title": "Audit and security",
  "settings.microsoft.manage_access_link": "Manage Microsoft account permissions",
  "settings.microsoft.privacy_policy": "Privacy policy",
  "settings.microsoft.terms_of_service": "Terms of service",
  "settings.microsoft.preview_unavailable": "Preview not available. The backend endpoint is not yet active.",
  "settings.microsoft.no_mail_items": "No mail items to display.",
  "settings.microsoft.no_drive_items": "No OneDrive files to display.",
  "settings.microsoft.no_sharepoint_items": "No SharePoint files to display.",
  "settings.microsoft.table.subject": "Subject",
  "settings.microsoft.table.from": "From",
  "settings.microsoft.table.received_at": "Received",
  "settings.microsoft.table.name": "Name",
  "settings.microsoft.table.type": "Type",
  "settings.microsoft.table.size": "Size",
  "settings.microsoft.table.modified": "Modified",
  "settings.microsoft.table.location": "Location",
  "settings.microsoft.table.time": "Time",
  "settings.microsoft.table.message": "Message",
  "settings.microsoft.table.scopes": "Scopes",
  "settings.microsoft.mail_reauth_required": "This account requires reauthorization to load mail.",
  "settings.microsoft.drive_reauth_required": "This account requires reauthorization to load files.",
  "settings.microsoft.reauthorize_preview": "Reauthorize",
  "settings.microsoft.mail_not_found": "Microsoft account not found. Check account settings.",
  "settings.microsoft.drive_not_found": "Microsoft drive not found.",
  "settings.microsoft.table.body_preview": "Preview",
  "settings.microsoft.table.has_attachments": "Attachments",
  "settings.microsoft.table.created_by": "Created by",
};
